/** App Spy › AdMob block requests (admins only): picking apps, the request form, the requests tab. */
export const admobBlock: Record<string, string> = {
  'admobBlock.tab': 'Yêu cầu chặn',
  'admobBlock.tab.intro': 'Yêu cầu chặn app đối thủ trong AdMob › Blocking controls. Admin gửi yêu cầu, executor duyệt (hoặc yêu cầu được duyệt ngay khi gửi), extension thực hiện trong trình duyệt của executor.',
  'admobBlock.apps': 'app',

  // Picking rows in Search / Top Charts
  'admobBlock.pickAll': 'Chọn tất cả app Android đang hiện',
  'admobBlock.pickApp': 'Chọn để chặn',
  'admobBlock.selected': 'app đã chọn',
  'admobBlock.limitNote': 'tối đa 50 app một yêu cầu',
  'admobBlock.requestBtn': 'Yêu cầu chặn',
  'admobBlock.requestPackagesBtn': 'Yêu cầu chặn app…',
  'admobBlock.clearSelection': 'Bỏ chọn',
  'admobBlock.badge.blocked': 'Đã chặn',
  'admobBlock.badge.waiting': 'Chờ chặn',
  'admobBlock.badge.open': 'Mở yêu cầu đang giữ app này',

  // The request form
  'admobBlock.form.title': 'Yêu cầu chặn app trên AdMob',
  'admobBlock.form.help': 'Gửi xong, executor được báo (chuông và Discord). App chỉ bị chặn trên tài khoản AdMob đã chọn khi yêu cầu đã được duyệt, bởi executor hoặc ngay khi gửi nếu người gửi được duyệt sẵn, và extension đã chạy. Chỉ app Android.',
  'admobBlock.form.account': 'Tài khoản AdMob',
  'admobBlock.form.pickAccount': 'Chọn tài khoản…',
  'admobBlock.form.noAccounts': 'Chưa có tài khoản AdMob nào được đăng ký để chặn. Nhờ executor thêm ở tab Yêu cầu chặn.',
  'admobBlock.form.picked': 'App đã chọn từ App Spy',
  'admobBlock.form.remove': 'Bỏ app này',
  'admobBlock.form.paste': 'Package khác (mỗi dòng một package, hoặc cách nhau bằng dấu phẩy; dán link Google Play cũng được)',
  'admobBlock.form.invalid': 'Không phải package Android (sửa hoặc xoá thì mới gửi được)',
  'admobBlock.form.reason': 'Lý do (5–500 ký tự)',
  'admobBlock.form.reasonShort': 'Lý do còn quá ngắn',
  'admobBlock.form.overLimit': 'Phần vượt giới hạn sẽ bị bỏ',
  'admobBlock.form.left': 'app bị bỏ',
  'admobBlock.form.send': 'Gửi yêu cầu',
  'admobBlock.form.sent': 'Đã gửi yêu cầu cho executor',
  'admobBlock.form.sentApproved': 'Đã gửi và được duyệt sẵn, sẵn sàng để chạy',
  'admobBlock.form.waits.ADMOB_BLOCK_DISABLED': 'Cầu nối chặn đang tắt nên yêu cầu chưa được duyệt sẵn. Executor duyệt khi cầu nối bật lại.',
  'admobBlock.form.waits.ADMOB_BLOCK_SNAPSHOT_STALE': 'Lần đọc console đã quá 24 giờ hoặc chưa có nên yêu cầu chưa được duyệt sẵn. Các app nằm trong yêu cầu này, nên đừng gửi lại. Cần một lần đọc console mới: executor chỉ duyệt được yêu cầu này sau lần đọc đó, và chỉ yêu cầu gửi lần sau, sau lần đọc đó, mới được duyệt sẵn (nút Đọc console ở bảng Tài khoản; không có nút đó thì nhờ executor đọc).',
  'admobBlock.form.waits.ADMOB_BLOCK_CAP': 'Không còn chỗ dưới hạn mức app bị chặn của AdMob nên yêu cầu chưa được duyệt sẵn. Executor sẽ quyết định.',
  'admobBlock.form.readFirst': 'Lần đọc console đã quá 24 giờ hoặc chưa có: yêu cầu gửi lúc này sẽ không được duyệt sẵn. Bấm Đọc console ở bảng Tài khoản trước khi gửi.',
  'admobBlock.form.skippedTitle': 'App không đưa vào yêu cầu',
  'admobBlock.form.viewRequest': 'Xem yêu cầu',
  'admobBlock.form.openHolder': 'xem yêu cầu',
  'admobBlock.skipped.ALREADY_BLOCKED': 'đã bị chặn trên console (lần đọc gần nhất)',
  'admobBlock.skipped.ALREADY_REQUESTED': 'đã nằm trong một yêu cầu khác của tài khoản này',

  // Statuses
  'admobBlock.status.PENDING': 'Chờ duyệt',
  'admobBlock.status.APPROVED': 'Đã duyệt',
  'admobBlock.status.DONE': 'Hoàn tất',
  'admobBlock.status.PARTIAL': 'Một phần',
  'admobBlock.status.REJECTED': 'Từ chối',
  'admobBlock.item.QUEUED': 'Chờ chạy',
  'admobBlock.item.CLAIMED': 'Đang chạy',
  'admobBlock.item.BLOCKED': 'Đã chặn',
  'admobBlock.item.ALREADY_BLOCKED': 'Đã chặn sẵn',
  'admobBlock.item.FAILED': 'Lỗi',
  'admobBlock.item.SKIPPED': 'Bỏ qua',

  // Banners
  'admobBlock.banner.off': 'Cầu nối chặn đang tắt: yêu cầu vẫn được gửi và xếp hàng, nhưng chưa thể duyệt hay chạy cho tới khi executor bật lại.',
  'admobBlock.banner.noAccounts': 'Chưa có tài khoản AdMob nào được đăng ký để chặn. Executor thêm tài khoản ở bảng bên dưới.',
  'admobBlock.banner.stale': 'lần đọc console đã cũ hơn 24 giờ: executor bấm Đọc console ở bảng Tài khoản trước khi duyệt hoặc chạy',
  'admobBlock.banner.neverRead': 'chưa đọc lần nào',
  'admobBlock.banner.neverReadFull': 'chưa đọc console của tài khoản này: executor bấm Đọc console ở bảng Tài khoản trước khi duyệt hoặc chạy',
  'admobBlock.banner.readOnly': 'Tài khoản của bạn không có hồ sơ nhân viên: xem được nhưng không gửi được yêu cầu.',
  'admobBlock.banner.delegate': 'Tài khoản này chạy thay executor: đọc console, gửi yêu cầu, chạy yêu cầu đã được duyệt và tắt cầu nối. Duyệt, từ chối, huỷ, thử lại, đăng ký tài khoản và bật cầu nối là việc của executor, làm bằng phiên của họ.',
  'admobBlock.unit.hours': 'giờ',
  'admobBlock.unit.days': 'ngày',

  // Accounts
  'admobBlock.accounts.title': 'Tài khoản AdMob',
  'admobBlock.accounts.account': 'Tài khoản',
  'admobBlock.accounts.blocked': 'Đã chặn / hạn mức',
  'admobBlock.accounts.read': 'Lần đọc console',
  'admobBlock.accounts.session': 'Phiên chạy',
  'admobBlock.accounts.stale': 'cũ',
  'admobBlock.accounts.busy': 'Đang chạy',
  'admobBlock.accounts.free': 'Rảnh',
  'admobBlock.accounts.extensionNote': 'Số liệu lấy từ console AdMob qua extension của executor. Chưa có lần đọc nào nên chưa thể duyệt yêu cầu: executor bấm Đọc console ở dòng tài khoản.',
  'admobBlock.read.button': 'Đọc console',
  'admobBlock.read.busy': 'Đang đọc…',
  'admobBlock.read.done': 'Đã đọc console của {label}: {used} trên {limit} app đã chặn.',
  'admobBlock.read.err.noExtension': 'Extension AdMob Console Bridge không trả lời trong trình duyệt này. Cài hoặc bật extension, rồi tải lại trang này.',
  'admobBlock.read.err.oldExtension': 'Extension AdMob Console Bridge ở trình duyệt này là bản cũ, chưa làm được việc này. Cập nhật extension, tải lại tiện ích rồi tải lại trang này.',
  'admobBlock.read.err.noSession': 'Extension chưa thấy phiên AdMob. Mở admob.google.com trong trình duyệt này, đăng nhập đúng tài khoản, mở trang Apps hoặc Mediation của nó rồi bấm lại.',
  'admobBlock.read.err.noToken': 'Extension chưa lấy được mã truy cập của Blocking controls. Mở trang Blocking controls của AdMob, mục App install ads, rồi quay lại bấm ngay.',
  'admobBlock.read.err.timeout': 'Extension không trả lời kịp. Bấm lại; nếu vẫn vậy, tải lại tiện ích rồi tải lại trang này.',
  'admobBlock.read.err.wrongAccount': 'Trình duyệt đang đăng nhập AdMob bằng publisher khác: {signedIn}. Đăng nhập đúng tài khoản {expected} rồi đọc lại.',
  'admobBlock.read.err.console': 'Console AdMob hoặc extension không trả lời như mong đợi: {detail}',
  'admobBlock.run.button': 'Chạy trên trình duyệt này',
  'admobBlock.run.bridgeOff': 'Cầu nối đang tắt: bật lại ở bảng Tài khoản thì mới chạy được.',
  'admobBlock.run.elsewhere': 'Tab này đang chạy một yêu cầu khác.',
  'admobBlock.run.confirmTitle': 'Chạy yêu cầu này?',
  'admobBlock.run.confirm': 'Extension sẽ chặn {n} app trên tài khoản {label}, publisher {publisher}, từ trình duyệt này, từng app một, cách nhau vài giây. Giữ tab này mở cho tới khi xong; đóng tab hoặc rời yêu cầu thì phần chưa làm được xếp lại hàng đợi.',
  'admobBlock.run.confirmButton': 'Chạy',
  'admobBlock.run.stop': 'Dừng',
  'admobBlock.run.stopping': 'Đang dừng…',
  'admobBlock.run.dismiss': 'Đóng',
  'admobBlock.run.phase.checking': 'Đang kiểm tra extension và tài khoản AdMob…',
  'admobBlock.run.phase.reading': 'Đang đọc console để làm mới lần đọc đã lưu…',
  'admobBlock.run.phase.claiming': 'Đang nhận đợt app từ máy chủ…',
  'admobBlock.run.phase.working': 'Đợt {batch}, app {index} trên {total}: {package}',
  'admobBlock.run.phase.verifying': 'Đang đọc lại console để đối chiếu…',
  'admobBlock.run.counts': 'Đã chặn {blocked}, đã chặn sẵn {already}, lỗi {failed}, bỏ qua {skipped}',
  'admobBlock.run.done': 'Xong. Số đợt đã chạy: {batches}.',
  'admobBlock.run.nothingLeft': 'Máy chủ không còn app nào để giao. Tải lại yêu cầu để xem nó kết thúc ra sao.',
  'admobBlock.run.donePartial':'Đã chạy hết, số đợt {batches}, nhưng yêu cầu ở trạng thái {status}: còn app chưa xong. Xem các app Lỗi hoặc Bỏ qua bên dưới rồi bấm Thử lại.',
  'admobBlock.run.stopped': 'Đã dừng theo yêu cầu. Phần chưa làm đã được trả về hàng đợi; nếu bảng Tài khoản vẫn báo tài khoản đang chạy, bấm Giải phóng phiên.',
  'admobBlock.run.writeFailed': 'Console không nhận lệnh chặn {package}: {detail}. Các app còn lại của đợt được bỏ qua. Khi yêu cầu ở trạng thái Một phần, bấm Thử lại để chạy tiếp.',
  'admobBlock.run.unknownOutcome': 'Đã gửi lệnh chặn {package} nhưng console không trả lời rõ, và lần tra lại không thấy app bị chặn: {detail}. Kiểm tra tay trên console. App được ghi là Lỗi, các app còn lại của đợt là Bỏ qua; nếu app thật ra đã bị chặn thì Thử lại sẽ thấy nó là đã chặn sẵn.',
  'admobBlock.run.throttled': 'Extension tự dừng vì chạy quá nhanh: {detail}. App bị dừng chưa gửi lệnh nào. Chờ một lúc rồi chạy lại yêu cầu.',
  'admobBlock.run.accountChanged': 'Máy chủ đã đổi publisher của tài khoản này sang {publisher}. Dừng, không gửi lệnh nào.',
  'admobBlock.run.lostClaim': 'Máy chủ không còn coi đợt này là của bạn: phiên hết hạn hoặc đã được giải phóng. Dừng. Nhiều nhất là app đang làm dở vẫn được gửi đi, lần chạy sau sẽ thấy nó là đã chặn sẵn. Tải lại yêu cầu để xem trạng thái từng app.',
  'admobBlock.run.settleMismatch': 'Máy chủ chỉ ghi nhận {settled} trên {sent} kết quả của đợt. Dừng. Tải lại yêu cầu rồi chạy tiếp.',
  'admobBlock.run.settleFailed': 'Chưa báo được kết quả app vừa làm cho máy chủ: {reason}. Đợt đã được trả về hàng đợi; app đã chặn trên console sẽ hiện là đã chặn sẵn ở lần chạy sau.',
  'admobBlock.run.snapshotFailed': 'Đợt đã xong nhưng chưa lưu được lần đọc console sau đợt: {reason}. Bấm Đọc console ở bảng Tài khoản để lưu lại.',
  'admobBlock.run.readBackFailed': 'Đợt đã được báo, nhưng chưa đọc lại được console để đối chiếu. Khi xử lý xong, bấm Đọc console ở bảng Tài khoản: {reason}',
  'admobBlock.run.drift': 'Console không liệt kê một số app đã báo là chặn, nên máy chủ đã ghi {n} app là Lỗi. Kiểm tra trên console trước khi chạy tiếp.',
  'admobBlock.run.bridgeSwitchedOff': 'Máy chủ đã tự tắt cầu nối vì console không xác nhận app vừa chặn. Kiểm tra trên console rồi mới bật lại.',
  'admobBlock.run.bridgeOffByHand': 'Cầu nối đã bị tắt trong lúc chạy nên đã dừng. Bật lại ở bảng Tài khoản rồi mới chạy tiếp.',
  'admobBlock.run.tooManyBatches': 'Đã chạy quá nhiều đợt trong một lần. Dừng; tải lại yêu cầu rồi chạy tiếp.',
  'admobBlock.run.busyMine': 'Nếu tab đang giữ tài khoản đã đóng, bấm Giải phóng phiên ở bảng Tài khoản.',
  'admobBlock.bridge.on': 'Cầu nối: bật',
  'admobBlock.bridge.off': 'Cầu nối: tắt',
  'admobBlock.switch.on': 'Bật cầu nối',
  'admobBlock.switch.off': 'Tắt cầu nối',
  'admobBlock.switch.onTitle': 'Bật lại cầu nối chặn?',
  'admobBlock.switch.offTitle': 'Tắt cầu nối chặn?',
  'admobBlock.switch.onConfirm': 'Yêu cầu có thể được duyệt và chạy trở lại. Chỉ bật khi đã kiểm tra vì sao nó tự tắt.',
  'admobBlock.switch.offConfirm': 'Dừng duyệt và chạy mọi yêu cầu. Yêu cầu mới vẫn được gửi và xếp hàng.',
  'admobBlock.release.title': 'Giải phóng phiên cũ?',
  'admobBlock.release.confirm': 'Chỉ dùng khi tab đang chạy đã đóng. Các app đang chạy dở được xếp lại hàng đợi và mọi báo cáo của tab đó sẽ bị từ chối; nếu tab vẫn đang chạy thật thì lượt chạy của nó hỏng.',
  'admobBlock.release.button': 'Giải phóng phiên',
  'admobBlock.release.freed': 'Đã giải phóng phiên; số app xếp lại hàng đợi',
  'admobBlock.release.notFreed': 'Không giải phóng được: phiên đang do người khác giữ hoặc đã hết. Phiên tự hết sau tối đa 10 phút.',
  'admobBlock.account.add': 'Thêm tài khoản',
  'admobBlock.account.key': 'Mã ngắn',
  'admobBlock.account.label': 'Tên hiển thị',
  'admobBlock.account.publisher': 'Publisher ID',
  'admobBlock.account.repointNote': 'Đổi publisher sẽ xoá lần đọc console đã lưu, và bị từ chối khi còn yêu cầu đang mở hoặc có phiên đang chạy.',
  'admobBlock.account.repointTitle': 'Đổi publisher của tài khoản?',
  'admobBlock.account.repointConfirm': 'Lần đọc console đã lưu của tài khoản này bị xoá, extension phải đọc lại trước khi chặn tiếp. Chỉ đổi khi tài khoản AdMob thật sự chuyển sang publisher khác.',
  'admobBlock.account.keyTaken': 'Mã này đã có: dùng nút Sửa ở dòng tài khoản đó.',

  // Requests
  'admobBlock.list.title': 'Danh sách yêu cầu',
  'admobBlock.list.mine': 'Của tôi',
  'admobBlock.list.all': 'Tất cả',
  'admobBlock.list.scope': 'Phạm vi',
  'admobBlock.list.status': 'Trạng thái',
  'admobBlock.list.anyStatus': 'Mọi trạng thái',
  'admobBlock.list.refresh': 'Làm mới',
  'admobBlock.list.created': 'Gửi lúc',
  'admobBlock.list.empty': 'Chưa có yêu cầu nào',
  'admobBlock.detail.title': 'Yêu cầu chặn',
  'admobBlock.detail.package': 'Package',
  'admobBlock.detail.status': 'Trạng thái',
  'admobBlock.detail.note': 'Ghi chú',
  'admobBlock.detail.done': 'đã chặn',
  'admobBlock.detail.open': 'đang chờ',
  'admobBlock.detail.stopped': 'dừng',
  'admobBlock.detail.requester': 'Người gửi',
  'admobBlock.detail.decidedBy': 'Người quyết định',
  'admobBlock.detail.autoApproved': 'tự duyệt theo danh sách',
  'admobBlock.detail.viaLogin': 'qua',
  'admobBlock.detail.reason': 'Lý do',
  'admobBlock.detail.rejectReason': 'Lý do từ chối',
  'admobBlock.detail.waitingForExecutor': 'Đang chờ executor duyệt.',
  'admobBlock.detail.refreshFailed': 'Chưa làm mới được, sẽ thử lại',
  'admobBlock.action.approve': 'Duyệt',
  'admobBlock.action.approveTitle': 'Duyệt yêu cầu chặn?',
  'admobBlock.action.approveConfirm': 'Sau khi duyệt, extension trong trình duyệt của executor sẽ chặn các app này trên tài khoản AdMob. Chỉ duyệt khi đúng là đối thủ cần chặn',
  'admobBlock.action.reject': 'Từ chối',
  'admobBlock.action.rejectTitle': 'Từ chối yêu cầu',
  'admobBlock.action.rejectHint': 'Người gửi được báo kèm lý do này.',
  'admobBlock.action.cancel': 'Huỷ yêu cầu',
  'admobBlock.action.back': 'Quay lại',
  'admobBlock.action.reasonShort': 'Lý do còn quá ngắn',
  'admobBlock.action.cancelTitle': 'Huỷ yêu cầu',
  'admobBlock.action.cancelHint': 'Các app chưa chạy bị bỏ qua và người gửi được báo kèm lý do. App đang chạy trong một trình duyệt thì không bị thu hồi.',
  'admobBlock.action.retry': 'Thử lại',
  'admobBlock.action.retryTitle': 'Thử lại các app chưa xong?',
  'admobBlock.action.retryConfirm': 'Các app lỗi hoặc bị bỏ qua được xếp lại hàng đợi',

  // Errors: one per code the server sends, then the fallbacks
  'admobBlock.err.ADMOB_BLOCK_NOT_EXECUTOR': 'Chỉ executor mới làm được việc này.',
  'admobBlock.err.ADMOB_BLOCK_NO_EMPLOYEE': 'Tài khoản này không có hồ sơ nhân viên nên không gửi hay xử lý được yêu cầu.',
  'admobBlock.err.ADMOB_BLOCK_DISABLED': 'Cầu nối chặn đang tắt.',
  'admobBlock.err.ADMOB_BLOCK_ACCOUNT_UNKNOWN': 'Tài khoản AdMob này chưa được đăng ký để chặn.',
  'admobBlock.err.ADMOB_BLOCK_REQUEST_UNKNOWN': 'Không tìm thấy yêu cầu này.',
  'admobBlock.err.ADMOB_BLOCK_ACCOUNT_MISMATCH': 'Trình duyệt đang đăng nhập publisher khác với tài khoản đã đăng ký.',
  'admobBlock.err.ADMOB_BLOCK_NOTHING_TO_DO': 'Mọi app đều đã bị chặn hoặc đã nằm trong yêu cầu khác.',
  'admobBlock.err.ADMOB_BLOCK_OPEN_LIMIT': 'Bạn đang có quá nhiều yêu cầu chờ xử lý; chờ quyết định trước khi gửi thêm.',
  'admobBlock.err.ADMOB_BLOCK_STATE': 'Yêu cầu vừa đổi trạng thái; tải lại để xem trạng thái mới.',
  'admobBlock.err.ADMOB_BLOCK_SNAPSHOT_STALE': 'Lần đọc console đã quá 24 giờ hoặc chưa có: bấm Đọc console ở bảng Tài khoản rồi thử lại.',
  'admobBlock.err.ADMOB_BLOCK_CAP': 'Không còn chỗ dưới hạn mức app bị chặn của AdMob',
  'admobBlock.err.ADMOB_BLOCK_BUSY': 'Một trình duyệt khác đang chạy trên tài khoản này.',
  'admobBlock.err.ADMOB_BLOCK_RATE': 'Đã chạy quá nhiều app trong một giờ trên tài khoản này; chờ một lúc.',
  'admobBlock.err.ADMOB_BLOCK_NOT_CLAIMED': 'Phiên chạy này không còn thuộc về bạn.',
  'admobBlock.err.ADMOB_BLOCK_IN_FLIGHT': 'Có app đang chạy trong một trình duyệt: chờ nó xong hoặc giải phóng phiên rồi huỷ lại.',
  'admobBlock.err.ADMOB_BLOCK_HUMAN_ONLY': 'Tài khoản chạy thay không quyết định được việc này: executor làm bằng phiên của họ.',
  'admobBlock.err.account.state': 'Chưa đổi publisher được: tài khoản còn yêu cầu đang mở hoặc đang có phiên chạy.',
  'admobBlock.err.cancel.nothingToDo': 'Không còn app nào đang chờ chạy nên không có gì để huỷ.',
  'admobBlock.err.forbidden': 'Bạn không có quyền làm việc này.',
  'admobBlock.err.signedOut': 'Phiên đăng nhập đã hết, hãy tải lại trang.',
  'admobBlock.err.network': 'Không kết nối được máy chủ.',
  'admobBlock.err.server': 'Máy chủ đang tạm thời gặp sự cố.',
  'admobBlock.err.unknown': 'Có lỗi xảy ra, thử lại sau.',

  // The numbers at the end of an error, each next to what it counts ({n} is where the number goes)
  'admobBlock.fact.running': '{n} app đang chạy',
  'admobBlock.fact.readAgo': 'đọc cách đây {n} giờ',

  // Notes the server writes on an app
  'admobBlock.note.rejected': 'Yêu cầu bị từ chối',
  'admobBlock.note.released': 'Phiên chạy được giải phóng, app xếp lại hàng đợi',
  'admobBlock.note.expired': 'Phiên chạy hết hạn, app xếp lại hàng đợi',
  'admobBlock.note.drift': 'Console không liệt kê app này sau khi chặn',
  'admobBlock.note.cancelledBy': 'Huỷ bởi',
  'admobBlock.note.retryAfter': 'Lần thử trước',
};
